import React from 'react';
export const Header = () => {
  return <header className="bg-white border-b" data-id="element-170">
      <div className="max-w-[768px] mx-auto px-4 py-3 flex items-center justify-between" data-id="element-171">
        <div className="flex items-center gap-3" data-id="element-172">
          <div className="font-bold text-xl text-[#6A36FC]" data-id="element-173">Scoop</div>
          <div className="text-gray-400" data-id="element-174">×</div>
          <div className="text-gray-700" data-id="element-175">Vytalogy Wellness</div>
        </div>
        <div className="text-sm text-gray-500" data-id="element-176">Technical Demonstration</div>
      </div>
    </header>;
};